export { ReferralLandingPage as default } from '~/components/pages/ReferralLandingPage/ReferralLandingPage';
export { getServerSideProps } from '~/components/pages/ReferralLandingPage/getServerSideProps';
